import { withInstall } from '@sgui-plus/utils/with-install'

import ImageViewer from './src/image-viewer.vue'

export const SgImageViewer = withInstall(ImageViewer)
export default SgImageViewer

export * from './src/image-viewer'
